import * as React from "react";
import { Modal, Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useCancelAndReturnsModalContentSlot } from "../../../../../../context/context/CancelAndReturnsModalContentContext.js";
const CancelAndReturnsModal = ({ onCloseCancelReturnsModal }) => {
  const { getLabel } = useIntl();
  const { Slots } = useCancelAndReturnsModalContentSlot();
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen: true,
      onModalClose: onCloseCancelReturnsModal,
      showIcon: true,
      title: getLabel("account.cancelAndReturns.label"),
      footer: /* @__PURE__ */ React.createElement(
        Button,
        {
          caption: getLabel("common.actions.close"),
          onClick: onCloseCancelReturnsModal,
          variant: "outline"
        }
      )
    },
    /* @__PURE__ */ React.createElement(Slots.ModalContent, null)
  );
};
export {
  CancelAndReturnsModal as default
};
//# sourceMappingURL=CancelAndReturnsModal.js.map
